import { Booking, FamilyId } from "../../../../requests-module/src";
import { PackageEnum } from "../packageHelpers";

function checkIsPackageFlight(booking: Booking): boolean {
    // if we have a flight option on the state, we are on a fight pack.
    if (booking?.options?.find(option => option.familyId == FamilyId.FLIGHT)) {
        return true
    }

    //  todo - // better check if we set alwasy pff for flight packages.
    // if (booking?.packageCode == PackageEnum.PFF) {
    //     return true
    // }
    return false
}

export default checkIsPackageFlight